<script setup>
import defaultEmployeeImage from "@/assets/images/user.png";
import { computed, ref, watch } from "vue";

const props = defineProps({
  employee: {
    type: Object,
    required: true
  }
});
const baseUrl = ref(process.env.VUE_APP_BASE_URI);
const showModalEmployeeImage = ref(false);
const currentImageUrl = ref(defaultEmployeeImage);

const employeeImageUrl = computed(() => {
  if (!props.employee?.photo?.contentUrl) {
    return defaultEmployeeImage;
  }
  return baseUrl.value + props.employee.photo.contentUrl;
});

const isDefaultImage = computed(() => currentImageUrl.value === defaultEmployeeImage);

watch(employeeImageUrl, (imageUrl) => {
  currentImageUrl.value = imageUrl;
}, { immediate: true });

const showEmployeeImage = () => {
  if (!isDefaultImage.value) {
    showModalEmployeeImage.value = true;
  }
}

const useDefaultImage = () => {
  currentImageUrl.value = defaultEmployeeImage;
}
</script>

<template>
  <div class="media" :class="{ pointer: !isDefaultImage }">
    <img class="rounded-circle img-thumbnail" :src="currentImageUrl" :alt="`Foto de ${employee.fullName || employee.name || 'empleado'}`"
      :role="isDefaultImage ? undefined : 'button'" :tabindex="isDefaultImage ? undefined : 0"
      @keydown.enter.prevent="showEmployeeImage" @keydown.space.prevent="showEmployeeImage"
      @click="showEmployeeImage" @error="useDefaultImage" :title="isDefaultImage ? '' : 'Click para ampliar'">
  </div>
  <el-dialog class="dialog-employee-avatar" height="400px" v-model="showModalEmployeeImage"
    :title="employee.name + ' ' + employee.lastName" theme="secondary" size="small">
    <div class="d-flex justify-content-center mx-auto">
      <img class="img-modal mx-auto" :src="currentImageUrl"
        :alt="`Foto de ${employee.fullName || [employee.name, employee.lastName].filter(Boolean).join(' ') || 'empleado'}`">
    </div>
  </el-dialog>
</template>

<style scoped lang="scss">
.media {
  display: flex;
  gap: 10px;
  justify-content: center;
  align-items: center;
  background-color: #f5f5f5;
  border-radius: 50%;
  overflow: hidden;
  // aspect-ratio: 1/1;
  width: 56px;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.img-thumbnail {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.img-modal {
  width: 325px;
}

.modal-image {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}


@media (max-width:767px) {}
</style>
